import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../assets/styles/UseCases.scss";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import InsightsIcon from "@mui/icons-material/Insights";
import FavoriteIcon from "@mui/icons-material/Favorite";

const useCases = [
  {
    icon: <QueryStatsIcon />,
    title: "Analysts",
    description:
      "Build structured Smart Alerts, run historical pattern analysis against past matches, and pull head-to-head stats for deeper research.",
  },
  {
    icon: <SportsSoccerIcon />,
    title: "Advanced Fans",
    description:
      "Track every stat that matters for your team — shots, corners, momentum swings — instead of relying on a generic score alert.",
  },
  {
    icon: <InsightsIcon />,
    title: "Data-Driven Users",
    description:
      "Use Guru Vision's AI match analysis and the League Stats dashboard to read form, trends, and matchups at a glance.",
  },
  {
    icon: <FavoriteIcon />,
    title: "Sports Enthusiasts",
    description:
      "Follow the moments that matter without juggling ten different apps. Goal Guru filters the noise so you don't have to.",
  },
];

function UseCases() {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <div className="usecases-outer">
      <div className="usecases-header" data-aos="fade-up">
        <span className="section-eyebrow">Who It's For</span>
        <h2 className="section-title">Built for Data-Driven Football Fans</h2>
        <p className="section-description">
          Whether you follow one team closely or track matches across
          continents, Goal Guru adapts to how deeply you want to go.
        </p>
      </div>

      <div className="usecases-grid">
        {useCases.map((useCase, index) => (
          <div
            className="usecase-card"
            key={useCase.title}
            data-aos="fade-up"
            data-aos-delay={100 + index * 100}
          >
            <div className="usecase-icon">{useCase.icon}</div>
            <h3>{useCase.title}</h3>
            <p>{useCase.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UseCases;
